import { PBox } from "../../../theme/BaseTheme";

export const HowToSellNotionTemplates = () => {
    return <PBox></PBox>;
};
